import React from 'react';
import { TOKEN } from '../data/mock';

export default function TheCoin() {
  return (
    <section id="l3" className="chapter" style={{ flexDirection: 'column', justifyContent: 'center' }}>
      <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 20px', justifyContent: 'center' }}>
        <span style={{ height: 1, width: 60, background: 'linear-gradient(to left, #f3c04a, transparent)' }} />
        LIFE III &middot; THE COIN
      </div>
      <p className="big-prose" style={{ textAlign: 'center', margin: '0 auto 20px', maxWidth: 960 }}>
        On the reef floor, something golden<br />
        was <em><i>pumping</i></em>.
      </p>

      <div className="coin-wrap">
        <img src={TOKEN.coinImage} alt="FISHECoin: a goldfish with a gold bar body" />
        <div className="coin-ring" />
        <div className="coin-ring r2" />
      </div>

      <div className="acronym-block">
        {TOKEN.acronym.map((a, i) => (
          <div className="acronym-cell" key={a.letter} style={{ animationDelay: `${i * 0.12}s` }}>
            <span className="acronym-letter">{a.letter}</span>
            <span className="acronym-word">{a.word}</span>
          </div>
        ))}
      </div>

      <p className="hero-note font-sans" style={{ marginTop: 26 }}>
        ONE FISH. ONE BAR. THE CHART ONLY SWIMS UP.
      </p>
    </section>
  );
}
